import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * Optional install button/banner.
 * Add <InstallAppPrompt /> inside App's rendered layout if you want an in-app install prompt.
 * Browsers decide when beforeinstallprompt is available. iPhone users should use Safari > Share > Add to Home Screen.
 */
export default function InstallAppPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [installed, setInstalled] = useState(
    window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true
  );

  useEffect(() => {
    const onPrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
    };
    const onInstalled = () => {
      setInstalled(true);
      setInstallEvent(null);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || dismissed || !installEvent) return null;

  const install = async () => {
    await installEvent.prompt();
    await installEvent.userChoice;
    setInstallEvent(null);
  };

  return (
    <div style={{
      position: "fixed", right: 16, bottom: 16, zIndex: 9999, maxWidth: 340,
      display: "flex", alignItems: "center", gap: 12, padding: "12px 14px",
      borderRadius: 14, color: "#fff", background: "#0b1728",
      boxShadow: "0 8px 30px rgba(0,0,0,.22)", fontFamily: "inherit"
    }}>
      <img src="/logo-192.png" alt="" width="38" height="38"
        style={{ borderRadius: "50%", background: "#fff", objectFit: "contain" }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <strong style={{ display: "block", fontSize: 14 }}>Installer United Migrants</strong>
        <span style={{ display: "block", fontSize: 12, opacity: .8 }}>Ajouter l’application à l’écran d’accueil</span>
      </div>
      <button type="button" onClick={install} style={{
        border: 0, borderRadius: 8, background: "#ff821f", color: "#fff",
        padding: "9px 11px", fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap"
      }}>Installer</button>
      <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer" style={{
        border: 0, background: "transparent", color: "#fff", padding: 3, cursor: "pointer"
      }}><X size={17} /></button>
    </div>
  );
}
